//cs-ecommerce/src/store/product/getters.js
export function userListGetter (state) {
    return state.userList;
}

/*
export function userMailListGetter (state) {
    return state.userList.filter(category => category.TYPUPIDX==0);
}
*/